<div class="image">
    <button
            type="button"
            class="prl-zone-view__thumb-btn"
            (click)="openPreview()"
            [title]="selectedPromo?.name || 'Preview'"
    >
        @if (hasMultiplePromos) {
            <mx-image-carousel
                    class="prl-zone-view__carousel"
                    [images]="images"
                    (selectedIndexChange)="onImageChange($event)">
            </mx-image-carousel>
        } @else {
            <mx-thumbnail
                    [thumbnailUrl]="getThumbnailUrl(selectedPromo)"
                    [defaultThumbnailClass]="getThumbnailClass(selectedPromo)">
            </mx-thumbnail>
        }
    </button>
</div>